module.exports = {

    clearUserId: function(){
        window.localStorage.removeItem('uid')
        window.localStorage.removeItem('username')
        window.localStorage.removeItem('jwt')
    }

}